import { useTheme } from "@mui/material";
import type { BoxProps } from "@mui/material/Box";
import Box from "@mui/material/Box";
import { mergeSx } from "merge-sx";

export const InformationBox = ({ sx, ...props }: BoxProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={mergeSx(
        {
          backgroundColor: "secondary.contrastText",
          color: "text.secondary",
          padding: theme.spacing(2),
          borderRadius: "12px",
          fontSize: 13,
        },
        sx
      )}
      {...props}
    />
  );
};
